import Grid from '@material-ui/core/Grid'

interface Props {
  changed: boolean,
  handleSave: () => void
  handleCancel: () => void
}

const ControlButtons = ({ changed, handleSave, handleCancel }: Props) => changed && (
  <Grid container spacing={2} className='mv6'>
    <Grid item>
      <SaveButton {...{ handleSave }} />
    </Grid>
    <Grid item>
      <CancelButton {...{ handleCancel }} />
    </Grid>
  </Grid>
)

const SaveButton = ({ handleSave }: Pick<Props, 'handleSave'>) => (
  <a
    className='bg-teal white hover-white pv3 ph8 ba b--transparent br2 normal f6 lh-copy-variant hover-o-90 pointer'
    href={null}
    data-event-category='Account'
    data-event-action='Preferences save'
    onClick={() => handleSave()}
  >
    <span>Save</span>
  </a>
)

const CancelButton = ({ handleCancel }: Pick<Props, 'handleCancel'>) => (
  <a
    className='bg-white black pv3 ph8 ba br2 normal f6 lh-copy-variant hover-o-90 pointer'
    href={null}
    data-event-category='Account'
    data-event-action='Preferences cancel'
    onClick={() => handleCancel()}
  >
    <span>Cancel</span>
  </a>
)

export default ControlButtons
